export enum LightColor {
  LIGHT_PINK = 'LIGHT_PINK',
  LIGHT_BLUE = 'LIGHT_BLUE',
  LIGHT_PURPLE = 'LIGHT_PURPLE',
  CORAL = 'CORAL',
  SKY = 'SKY',
  ORCHID = 'ORCHID',
  WHITE = 'WHITE',
}
